// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"a40a07a1","453":"54292a4b","834":"01637e87"}[chunkId] + ".chunk.js";
};